/* label.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./label.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var fieldsetLabelStyles = null;

/**
 * __Label__
 *
 * A label represents a caption for an item in a user interface.
 *
 * It's recommended that a label has a `space.050` spacing above its associated
 * control element.
 */
export var Label = function Label(_ref) {
  var children = _ref.children,
    htmlFor = _ref.htmlFor,
    id = _ref.id,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("label", {
    id: id,
    htmlFor: htmlFor,
    "data-testid": testId,
    className: ax(["_11c8dcr7 _1e0c1o8l _syazazsu _k48pmoej _6rth1b66 _1pfhze3t"])
  }, children);
};

/**
 * __Legend__
 *
 * A Legend represents a caption for a fieldset in a user interface.
 */
export var Legend = function Legend(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("legend", {
    className: ax(["_11c8dcr7 _1e0c1o8l _syazazsu _k48pmoej _6rth1b66 _1pfhze3t"])
  }, children);
};